interface ConlicitasegRoute {
  path: string;
  withSubRoutes?: boolean;
}

const ConlicitasegOnlyRoutes: ConlicitasegRoute[] = [
  { path: '/painel' },
  { path: '/conlicitaseg', withSubRoutes: true },
  { path: '/boletim_web/public/boletins', withSubRoutes: true },
  { path: '/biddings', withSubRoutes: true },
  { path: '/banco_de_dados' },
  { path: '/planos' },
  { path: '/contato' },
  { path: '/editar_contato' },
  { path: '/ajuda' },
  { path: '/assinatura_paralisada' },
  { path: '/assinatura_vencida' },
  { path: '/recurso_inativo' },
  { path: '/cadastrar' },
  { path: '/cadastro' },
];

export const isConlicitasegAllowedRoute = (pathname: string): boolean =>
  ConlicitasegOnlyRoutes.some(
    ({ path, withSubRoutes }) =>
      pathname === path || (!!withSubRoutes && pathname.startsWith(`${path}/`)),
  );

export default ConlicitasegOnlyRoutes;
